import PxoProdutividadeTable        from './PxoProdutividadeTable'
import api                          from '../../../../services/api'

import { useEffect, useState }      from 'react'
import { usePxoPage }               from "../../../../contexts/PxoPageContext"
import PxoLoadingTable                    from '../PxoLoadingTable'

const PxoProdutividadeTableContainer = ({segment}) => {

    const { selectedDate, selectedHorizonTypeId, updateProdutividadeTable, setNotFoundTables } = usePxoPage()

    const [ _pxoProdutividadeTableData,       _setPxoProdutividadeTableData        ] = useState(null)
    const [ _pxoProdutividadeTableMedianData, _setPxoProdutividadeTableMedianData  ] = useState(null)
    
    const [ _isLoading, _setIsLoading ] = useState(true)

    const [ tryFecthAgain, setTryFetchAgain ] = useState(false)

    const fetchPxoProdutividadeTable = async () => {
        
        _setIsLoading(true)
        setNotFoundTables(false)
        
        try {
            
            if (!selectedDate || !selectedHorizonTypeId) return

            const response = await api.get(`/getPxoProdutividadeTable`, {
                params: {
                    selectedDate,
                    pxoHorizonId: selectedHorizonTypeId,
                    segment
                },
                timeout: 15000 
            })

            const { pxoProdutividadeTable, pxoProdutividadeTableMedian } = response.data

            _setPxoProdutividadeTableData(pxoProdutividadeTable)
            _setPxoProdutividadeTableMedianData(pxoProdutividadeTableMedian)
      
        } catch (error) {
            
            _setPxoProdutividadeTableData(null)
            _setPxoProdutividadeTableMedianData(null)
            setNotFoundTables(true)
            
            if (error.response?.status !== 404 && error.response?.status !== 400) console.log(error)
        }
        _setIsLoading(false)
    }

    useEffect(() => {
        setNotFoundTables(false)
        fetchPxoProdutividadeTable()

    }, [selectedDate, selectedHorizonTypeId, updateProdutividadeTable, tryFecthAgain ])

    return  (

        <div className='text-center w-fit flex flex-col gap-2'>
            
            <h2> Produtividade (vgs/h) </h2>
            
            <div className='flex flex-row gap-4 '>
                
                {_isLoading ? (
                    <>
                        <PxoLoadingTable
                            rows={segment == "granel" ? 20 : 12}
                            cols={5}
                            headerColor="bg-[#00C64C]"
                        />
                        <PxoLoadingTable
                            rows={segment == "granel" ? 20 : 12}
                            cols={1}
                            headerColor="bg-[#00C64C]"
                        />
                    </>
                ) : _pxoProdutividadeTableData && _pxoProdutividadeTableMedianData ? (
                    <>
                        <PxoProdutividadeTable
                            isEditable={true}
                            allowNames={true}
                            tableData={_pxoProdutividadeTableData}
                        />
                        
                        <PxoProdutividadeTable
                            isEditable={false}
                            allowNames={false}
                            tableData={_pxoProdutividadeTableMedianData}
                        />
                    </>
                ) : (
                        <div className="
                            w-full
                            text-center
                            bg-gray-100
                            h-full
                            p-2.5
                             border
                            border-gray-300
                            rounded
                            cursor-pointer
                            hover:bg-gray-200
                            transition
                        "
                        onClick={() => setTryFetchAgain(!tryFecthAgain)}
                        >
                        Nenhuma informação encontrada.
                        <p className='text-[10px]'>(clique para tentar novamente)</p>
                    </div>
                )}
            </div>

        </div>
    )
}

export default PxoProdutividadeTableContainer   